import { enablePointerEvents } from '@utils/pointer-events-control';
import { gameState } from '../index';

let cam;
let sections = [2, 3, 4, 5, 6];
let qno = 1;
let switch1Toggle = 0;
let switch2Toggle = 0;
let switch3Toggle = 0;
let switch4Toggle = 0;
let red1 = false;
let red2 = false;
let red3 = false;
let red4 = false;
let load1 = false;
let load3 = false;

export default class GameScene extends Phaser.Scene {
  constructor() {
    super({
      key: 'GameScene',
    });
  }

  preload() {}

  create() {
    // Enable pointer events so hover states and the cursor work
    enablePointerEvents();

    sections = [2, 3, 4, 5, 6];
    qno = 1;
    switch1Toggle = 0;
    switch2Toggle = 0;
    switch3Toggle = 0;
    switch4Toggle = 0;
    red1 = false;
    red2 = false;
    red3 = false;
    red4 = false;

    cam = this.cameras.main;
    cam.fadeIn(200, 255, 255, 255);
    this.scene.launch('HintScene');
    this.add.sprite(0, 0, 'gameBG').setOrigin(0);
    this.section2 = this.add.sprite(18, 157, 'section2').setOrigin(0);
    this.section3 = this.add.sprite(277, 157, 'section3').setOrigin(0);
    this.section4 = this.add.sprite(277, 334, 'section4').setOrigin(0);
    this.section5 = this.add.sprite(277, 519, 'section5').setOrigin(0);
    this.section6 = this.add.sprite(539, 334, 'section6').setOrigin(0);
    this.overlay = this.add.sprite(0, 0, 'overlay').setOrigin(0);
    this.section1 = this.add.sprite(18, 334, 'section1').setOrigin(0);
    this.glow1 = this.add.sprite(6.6, 326, 'glow1').setScale(0.99).setOrigin(0);

    this.redGlow = this.add
      .sprite(835, 157, 'redGlow')
      .setScale(0.99)
      .setAlpha(0)
      .setOrigin(0);
    this.switchBoard = this.add.sprite(845, 147, 'switchBoard').setOrigin(0);
    this.greenGlow = this.add
      .sprite(835, 157, 'greenGlow')
      .setScale(0.99)
      .setAlpha(0)
      .setOrigin(0);
    this.yellowGlow = this.add.sprite(980, 118, 'yellowGlow').setAlpha(0).setOrigin(0);
    this.redBulb = this.add.sprite(980, 118, 'redBulb').setAlpha(0).setOrigin(0);
    this.yellowGlow1 = this.add.sprite(203, 520, 'yellowGlow').setAlpha(0).setOrigin(0);

    this.yellowBorder1 = this.add
      .sprite(894, 198, 'yellowBorder')
      .setAlpha(0)
      .setOrigin(0);
    this.yellowBorder2 = this.add.sprite(1054, 198, 'yellowBorder').setOrigin(0);
    this.yellowBorder3 = this.add
      .sprite(894, 410, 'yellowBorder')
      .setAlpha(0)
      .setOrigin(0);
    this.yellowBorder4 = this.add
      .sprite(1054, 410, 'yellowBorder')
      .setAlpha(0)
      .setOrigin(0);
    this.fractionBox1 = this.add.sprite(909, 206, 'fractionBox').setOrigin(0);
    this.fractionBox2 = this.add.sprite(1069, 206, 'fractionBox').setOrigin(0);
    this.fractionBox3 = this.add.sprite(909, 418, 'fractionBox').setOrigin(0);
    this.fractionBox4 = this.add.sprite(1069, 418, 'fractionBox').setOrigin(0);
    this.container1 = this.add.container(0, 0, []);
    this.container2 = this.add.container(0, 0, []);
    this.container3 = this.add.container(0, 0, []);
    this.container4 = this.add.container(0, 0, []);

    this.anims.create({
      key: 'switchAnim',
      frames: this.anims.generateFrameNames('switchAnim', {
        start: 0,
        end: 0,
        zeroPad: 0,
        prefix: 'switch',
        suffix: '.png',
      }),
      frameRate: 24,
      repeat: 0,
    });
    this.anims.create({
      key: 'switchAnimGreen',
      frames: this.anims.generateFrameNames('switchAnim', {
        start: 1,
        end: 12,
        zeroPad: 0,
        prefix: 'switch',
        suffix: '.png',
      }),
      frameRate: 24,
      repeat: 0,
    });

    this.anims.create({
      key: 'confetti',
      frames: this.anims.generateFrameNames('confetti', {
        start: 1,
        end: 81,
        zeroPad: 0,
        prefix: 'confetti',
        suffix: '.png',
      }),
      frameRate: 24,
      repeat: 0,
    });

    this.switch1 = this.add
      .sprite(860.3, 140, 'switchAnim')
      .setOrigin(0)
      .play('switchAnim');
    this.switch2 = this.add
      .sprite(1022, 140, 'switchAnim')
      .setOrigin(0)
      .play('switchAnim');
    this.switch3 = this.add
      .sprite(860.3, 351.5, 'switchAnim')
      .setOrigin(0)
      .play('switchAnim');
    this.switch4 = this.add
      .sprite(1022, 351.5, 'switchAnim')
      .setOrigin(0)
      .play('switchAnim');

    this.q1 = this.add.sprite(920, 213, 'q1').setOrigin(0);
    this.q2 = this.add.sprite(1080, 213, 'q2').setOrigin(0);
    this.q3 = this.add.sprite(920, 427, 'q3').setOrigin(0);
    this.q4 = this.add.sprite(1080, 427, 'q4').setOrigin(0);
    this.hand = this.add.sprite(1087, 295, 'hand').setOrigin(0).setAlpha(0);
    this.confetti = this.add.sprite(1025, 240, 'confetti').setScale(0.6).setAlpha(0);
    this.confirm = this.add
      .sprite(1035, 800, 'confirm')
      .setInteractive({ cursor: 'pointer' });

    this.switch1.on(
      'pointerdown',
      function () {
        this.confirm.setVisible(true);
        this.cardSlide(this.confirm, 640);
        switch1Toggle = 1;
        this.switchToggle(switch1Toggle, this.yellowBorder1);
      },
      this,
    );

    this.switch2.on(
      'pointerdown',
      function () {
        this.confirm.setVisible(true);
        this.cardSlide(this.confirm, 640);
        this.hand.setAlpha(0);
        if (gameState.questionNo == 2) {
          this.switch2.disableInteractive();
          gameState.correctAttempt = true;
          const scene1 = this.scene.get('HintScene');
          scene1.objectFadeOutIn(0, 1000, 250);
        }
        if (gameState.questionNo >= 5) {
          switch2Toggle = 1;
          this.switchToggle(switch2Toggle, this.yellowBorder2);
        }
      },
      this,
    );

    this.switch3.on(
      'pointerdown',
      function () {
        this.confirm.setVisible(true);
        this.cardSlide(this.confirm, 640);
        switch3Toggle = 1;
        this.switchToggle(switch3Toggle, this.yellowBorder3);
      },
      this,
    );

    this.switch4.on(
      'pointerdown',
      function () {
        this.confirm.setVisible(true);
        this.cardSlide(this.confirm, 640);
        switch4Toggle = 1;
        this.switchToggle(switch4Toggle, this.yellowBorder4);
      },
      this,
    );

    this.confirm.on(
      'pointerover',
      function () {
        this.confirm.setTexture('confirmBlack');
      },
      this,
    );

    this.confirm.on(
      'pointerout',
      function () {
        this.confirm.setTexture('confirm');
      },
      this,
    );

    this.confirm.on(
      'pointerdown',
      function () {
        this.switch1.disableInteractive();
        this.switch2.disableInteractive();
        this.switch3.disableInteractive();
        this.switch4.disableInteractive();

        this.tweens.add({
          targets: this.confirm,
          scale: 0.8,
          ease: 'linear',
          duration: 200,
          delay: 25,
          yoyo: true,
          repeat: 0,
          onComplete: () => {
            this.time.delayedCall(
              400,
              () => {
                this.confirm.setVisible(false);
                this.confirm.y = 800;
              },
              [],
              this,
            );
          },
        });

        if (gameState.questionNo == 2) {
          gameState.correctCount++;
          this.check();
        }

        if (gameState.questionNo == 5) {
          if (
            this.yellowBorder2.alpha == 1 &&
            this.yellowBorder3.alpha == 1 &&
            this.yellowBorder1.alpha == 0 &&
            this.yellowBorder4.alpha == 0
          ) {
            gameState.correctAttempt = true;
            gameState.correctCount++;
            this.check();
          } else {
            this.wrongEffect();
          }
        }

        if (gameState.questionNo == 6 || gameState.questionNo == 11) {
          if (
            this.yellowBorder1.alpha == 1 &&
            this.yellowBorder2.alpha == 1 &&
            this.yellowBorder3.alpha == 0 &&
            this.yellowBorder4.alpha == 0
          ) {
            gameState.correctAttempt = true;
            gameState.correctCount++;
            this.check();
          } else {
            this.wrongEffect();
          }
        }

        if (gameState.questionNo == 7) {
          if (
            this.yellowBorder1.alpha == 0 &&
            this.yellowBorder2.alpha == 1 &&
            this.yellowBorder3.alpha == 0 &&
            this.yellowBorder4.alpha == 0
          ) {
            gameState.correctAttempt = true;
            gameState.correctCount++;
            this.check();
          } else {
            this.wrongEffect();
          }
        }

        if (gameState.questionNo == 8) {
          if (
            this.yellowBorder1.alpha == 1 &&
            this.yellowBorder2.alpha == 0 &&
            this.yellowBorder3.alpha == 0 &&
            this.yellowBorder4.alpha == 0
          ) {
            gameState.correctAttempt = true;
            gameState.correctCount++;
            this.check();
          } else {
            this.wrongEffect();
          }
        }

        if (gameState.questionNo == 9 || gameState.questionNo == 10) {
          if (
            this.yellowBorder1.alpha == 0 &&
            this.yellowBorder2.alpha == 0 &&
            this.yellowBorder3.alpha == 1 &&
            this.yellowBorder4.alpha == 0
          ) {
            gameState.correctAttempt = true;
            gameState.correctCount++;
            this.check();
          } else {
            this.wrongEffect();
          }
        }

        if (gameState.questionNo == 12) {
          if (
            this.yellowBorder1.alpha == 1 &&
            this.yellowBorder2.alpha == 0 &&
            this.yellowBorder3.alpha == 1 &&
            this.yellowBorder4.alpha == 0
          ) {
            gameState.correctAttempt = true;
            gameState.correctCount++;
            this.check();
          } else {
            this.wrongEffect();
          }
        }

        if (gameState.questionNo == 13) {
          if (
            this.yellowBorder1.alpha == 0 &&
            this.yellowBorder2.alpha == 0 &&
            this.yellowBorder3.alpha == 0 &&
            this.yellowBorder4.alpha == 1
          ) {
            gameState.correctAttempt = true;
            gameState.correctCount++;
            this.check();
          } else {
            this.wrongEffect();
          }
        }
      },
      this,
    );
  }

  wrongEffect() {
    gameState.wrongAttempt++;
    if (gameState.wrongAttempt > 2) gameState.hintClose = true;
    gameState.wrongState = false;
    this.redGlow.setAlpha(1);
    this.redBulb.setAlpha(1);
    if (this.yellowBorder1.alpha == 1) {
      red1 = true;
      this.yellowBorder1.alpha = 0;
      this.switch1.setTexture('wrong');
      this.switch1.x += 37.3;
      this.switch1.y += 143.5;
    }
    if (this.yellowBorder2.alpha == 1) {
      red2 = true;
      this.yellowBorder2.alpha = 0;
      this.switch2.setTexture('wrong');
      this.switch2.x += 37.3;
      this.switch2.y += 143.5;
    }
    if (this.yellowBorder3.alpha == 1) {
      red3 = true;
      this.yellowBorder3.alpha = 0;
      this.switch3.setTexture('wrong');
      this.switch3.x += 37.3;
      this.switch3.y += 143.5;
    }
    if (this.yellowBorder4.alpha == 1) {
      red4 = true;
      this.yellowBorder4.alpha = 0;
      this.switch4.setTexture('wrong');
      this.switch4.x += 37.3;
      this.switch4.y += 143.5;
    }

    this.time.delayedCall(
      1500,
      () => {
        this.fadeInOut(this.redGlow);
        this.fadeInOut(this.redBulb);
        if (red1 == true) {
          this.switch1.setTexture('switchAnim');
          this.switch1.x -= 37.3;
          this.switch1.y -= 143.5;
        }
        if (red2 == true) {
          this.switch2.setTexture('switchAnim');
          this.switch2.x -= 37.3;
          this.switch2.y -= 143.5;
        }
        if (red3 == true) {
          this.switch3.setTexture('switchAnim');
          this.switch3.x -= 37.3;
          this.switch3.y -= 143.5;
        }
        if (red4 == true) {
          this.switch4.setTexture('switchAnim');
          this.switch4.x -= 37.3;
          this.switch4.y -= 143.5;
        }
        if (gameState.wrongAttempt < 3) {
          this.switch1.setInteractive();
          this.switch2.setInteractive();
          this.switch3.setInteractive();
          this.switch4.setInteractive();
        }
        red1 = false;
        red2 = false;
        red3 = false;
        red4 = false;
      },
      [],
      this,
    );

    this.time.delayedCall(
      1500,
      () => {
        const scene1 = this.scene.get('HintScene');
        scene1.wrong();
      },
      [],
      this,
    );
  }

  check() {
    gameState.wrongState = false;
    if (gameState.wrongAttempt > 0) gameState.hintClose = true;
    if (
      gameState.questionNo == 2 ||
      gameState.questionNo == 5 ||
      gameState.questionNo == 6 ||
      gameState.questionNo == 7 ||
      gameState.questionNo == 11
    )
      this.switch2.play('switchAnimGreen');
    if (
      gameState.questionNo == 5 ||
      gameState.questionNo == 9 ||
      gameState.questionNo == 10 ||
      gameState.questionNo == 12
    )
      this.switch3.play('switchAnimGreen');
    if (
      gameState.questionNo == 6 ||
      gameState.questionNo == 8 ||
      gameState.questionNo == 11 ||
      gameState.questionNo == 12
    )
      this.switch1.play('switchAnimGreen');
    if (gameState.questionNo == 13) this.switch4.play('switchAnimGreen');
    if (gameState.questionNo == 2) gameState.confirmClick = true;
    this.yellowBorder1.setAlpha(0);
    this.yellowBorder2.setAlpha(0);
    this.yellowBorder3.setAlpha(0);
    this.yellowBorder4.setAlpha(0);
    if (
      gameState.questionNo == 2 ||
      gameState.questionNo == 5 ||
      gameState.questionNo == 6 ||
      gameState.questionNo == 7
    )
      this.switch2.on(
        Phaser.Animations.Events.ANIMATION_COMPLETE_KEY + 'switchAnimGreen',
        () => {
          if (gameState.correctAttempt == true) this.correctEffect();
        },
        this,
      );

    if (
      gameState.questionNo == 8 ||
      gameState.questionNo == 11 ||
      gameState.questionNo == 12
    )
      this.switch1.on(
        Phaser.Animations.Events.ANIMATION_COMPLETE_KEY + 'switchAnimGreen',
        () => {
          if (gameState.correctAttempt == true) this.correctEffect();
        },
        this,
      );

    if (gameState.questionNo == 9 || gameState.questionNo == 10)
      this.switch3.on(
        Phaser.Animations.Events.ANIMATION_COMPLETE_KEY + 'switchAnimGreen',
        () => {
          if (gameState.correctAttempt == true) this.correctEffect();
        },
        this,
      );

    if (gameState.questionNo == 13)
      this.switch4.on(
        Phaser.Animations.Events.ANIMATION_COMPLETE_KEY + 'switchAnimGreen',
        () => {
          if (gameState.correctAttempt == true) this.correctEffect();
        },
        this,
      );
  }

  switchToggle(toggleVar, object) {
    if (toggleVar == 1 && object.alpha == 0) {
      object.setAlpha(1);
      toggleVar = 0;
    }

    if (toggleVar == 1 && object.alpha == 1) {
      object.setAlpha(0);
      toggleVar = 0;
    }
  }

  handTween() {
    this.hand.setAlpha(1);
    this.switch2.setInteractive({ cursor: 'pointer', pixelPerfect: true });
    this.tweens.add({
      targets: this.hand,
      y: 340,
      ease: 'linear',
      duration: 500,
      delay: 250,
      repeat: -1,
      yoyo: true,
    });
  }

  correctEffect() {
    this.yellowGlow.setAlpha(1);
    if (gameState.questionNo == 2) this.yellowGlow1.setAlpha(1);
    if (gameState.questionNo >= 5) {
      this.yellowGlow1.setScale(0.8).setDepth(7);
      if (this.room == 2) {
        this.yellowGlow1.x = 212;
        this.yellowGlow1.y = 268;
      }
      if (this.room == 3) {
        this.yellowGlow1.x = 625;
        this.yellowGlow1.y = 154;
      }
      if (this.room == 4) {
        this.yellowGlow1.x = 273;
        this.yellowGlow1.y = 439;
      }
      if (this.room == 5) {
        this.yellowGlow1.x = 440;
        this.yellowGlow1.y = 515;
      }
      if (this.room == 6) {
        this.yellowGlow1.x = 535;
        this.yellowGlow1.y = 545;
      }
      this.yellowGlow1.setAlpha(1);
    }

    this.time.delayedCall(
      350,
      () => {
        if (gameState.questionNo == 2) {
          this.glow1.setAlpha(0);
          this.section1.setTexture('litUp1');
          this.section1.setScale(0.99, 1);
        }
        if (gameState.questionNo >= 5) {
          if (this.room == 2) {
            this.glow2.setAlpha(0);
            this.section2.setTexture('litUp2');
          }
          if (this.room == 3) {
            this.glow3.setAlpha(0);
            this.section3.setTexture('litUp3');
            this.section3.x = 277.6;
            this.section3.y = 147;
          }
          if (this.room == 4) {
            this.glow4.setAlpha(0);
            this.section4.setTexture('litUp4');
            this.section4.x = 268;
          }
          if (this.room == 5) {
            this.glow5.setAlpha(0);
            this.section5.setTexture('litUp5');
            this.section5.x = 278;
            this.section5.y = 509;
            this.section5.setScale(1.001, 1);
          }
          if (this.room == 6) {
            this.glow6.setAlpha(0);
            this.section6.setTexture('litUp6');
            this.section6.x = 530;
            this.section6.setScale(0.998, 1);
          }
        }

        this.yellowGlow1.setAlpha(0);
        if (gameState.questionNo == 2) this.overlay.setAlpha(0);
      },
      [],
      this,
    );

    this.time.delayedCall(
      1000,
      () => {
        const scene1 = this.scene.get('HintScene');
        scene1.objectFadeOutIn(0, 1000, 250);

        this.confetti.setAlpha(1).play('confetti');
        this.greenGlow.setAlpha(1);
      },
      [],
      this,
    );
  }

  next() {
    this.fadeInOut(this.yellowGlow);
    this.fadeInOut(this.greenGlow);
    if (
      (gameState.questionNo == 2 ||
        gameState.questionNo == 5 ||
        gameState.questionNo == 6 ||
        gameState.questionNo == 7 ||
        gameState.questionNo == 11) &&
      gameState.wrongState == false
    ) {
      this.switch2.playReverse('switchAnimGreen');
      this.switch = this.switch2;
    }

    if (
      (gameState.questionNo == 5 ||
        gameState.questionNo == 9 ||
        gameState.questionNo == 10 ||
        gameState.questionNo == 12) &&
      gameState.wrongState == false
    ) {
      this.switch3.playReverse('switchAnimGreen');
      if (
        gameState.questionNo == 9 ||
        gameState.questionNo == 10 ||
        gameState.questionNo == 12
      )
        this.switch = this.switch3;
    }

    if (
      (gameState.questionNo == 6 ||
        gameState.questionNo == 8 ||
        gameState.questionNo == 11 ||
        gameState.questionNo == 12) &&
      gameState.wrongState == false
    ) {
      this.switch1.playReverse('switchAnimGreen');
      if (gameState.questionNo == 8) this.switch = this.switch1;
    }

    if (gameState.questionNo == 13 && gameState.wrongState == false) {
      this.switch4.playReverse('switchAnimGreen');
      this.switch = this.switch4;
    }

    this.switch.on(
      Phaser.Animations.Events.ANIMATION_COMPLETE_KEY + 'switchAnimGreen',
      () => {
        this.container1.add(this.fractionBox1);
        this.container1.add(this.q1);
        this.container2.add(this.fractionBox2);
        this.container2.add(this.q2);
        this.container3.add(this.fractionBox3);
        this.container3.add(this.q3);
        this.container4.add(this.fractionBox4);
        this.container4.add(this.q4);

        if (gameState.cardDown == true) {
          this.cardSlide(this.container1, 77);
          this.cardSlide(this.container2, 77);
          this.cardSlide(this.container3, 77);
          this.cardSlide(this.container4, 77);
        }
      },
      this,
    );

    if (gameState.cardDown == true && gameState.wrongState == true) {
      this.cardSlide(this.container1, 77);
      this.cardSlide(this.container2, 77);
      this.cardSlide(this.container3, 77);
      this.cardSlide(this.container4, 77);
    }

    this.time.delayedCall(
      1500,
      () => {
        const scene1 = this.scene.get('HintScene');

        if (gameState.wrongState == false && gameState.correctCount < 6 && qno < 10)
          scene1.textHolderTween(1002, 500, 50);

        if (gameState.wrongState == false && (gameState.correctCount >= 6 || qno >= 10)) {
          scene1.teraOut();
          this.time.delayedCall(
            1500,
            () => {
              this.sceneEnd();
            },
            [],
            this,
          );
        }
        if (gameState.wrongState == true) scene1.objectFadeOutIn(0, 1000, 250);
      },
      [],
      this,
    );

    if (gameState.wrongState == false) this.timer = 2500;
    if (gameState.wrongState == true) this.timer = 3600;

    this.time.delayedCall(
      this.timer,
      () => {
        if (gameState.wrongState == false) {
          if (qno < 10) this.cardChange();
          this.room = Phaser.Math.RND.pick(sections);

          for (let i = 0; i <= sections.length; i++) {
            if (sections[i] == this.room) {
              sections.splice(i, 1);
              break;
            }
          }

          if (this.room == 2)
            this.glow2 = this.add
              .sprite(this.section2.x - 9.8, this.section2.y - 11, 'glow2')
              .setScale(0.975, 0.94)
              .setDepth(10)
              .setOrigin(0);
          if (this.room == 3)
            this.glow3 = this.add
              .sprite(this.section3.x - 9.7, this.section3.y - 9, 'glow3')
              .setScale(0.99, 0.935)
              .setDepth(10)
              .setOrigin(0);
          if (this.room == 4)
            this.glow4 = this.add
              .sprite(this.section4.x - 8, this.section4.y - 8.7, 'glow4')
              .setScale(0.98, 0.969)
              .setDepth(10)
              .setOrigin(0);
          if (this.room == 5)
            this.glow5 = this.add
              .sprite(this.section5.x - 9, this.section5.y - 8.7, 'glow5')
              .setScale(0.98)
              .setDepth(10)
              .setOrigin(0);
          if (this.room == 6)
            this.glow6 = this.add
              .sprite(this.section6.x - 9.3, this.section6.y - 6, 'glow6')
              .setScale(0.97)
              .setDepth(10)
              .setOrigin(0);
        }
        qno += 1;
        gameState.totalAttempted = qno - 1;
        gameState.cardDown = false;
        gameState.wrongAttempt = 0;

        this.switch1.setInteractive({ cursor: 'pointer', pixelPerfect: true });
        this.switch2.setInteractive({ cursor: 'pointer', pixelPerfect: true });
        this.switch3.setInteractive({ cursor: 'pointer', pixelPerfect: true });
        this.switch4.setInteractive({ cursor: 'pointer', pixelPerfect: true });

        if (qno > 10 || gameState.correctCount >= 6) {
          this.switch1.disableInteractive();
          this.switch2.disableInteractive();
          this.switch3.disableInteractive();
          this.switch4.disableInteractive();
        }
      },
      [],
      this,
    );
  }

  fadeInOut(object) {
    this.tweens.add({
      targets: object,
      alpha: 0,
      ease: 'Cubic',
      duration: 1000,
      delay: 250,
      repeat: 0,
      onComplete: () => {
        this.time.delayedCall(
          2500,
          () => {
            if (qno == 2) {
              if (load1 == false) {
                this.load.multiatlas(
                  'spotlight',
                  'assets/EndSceneAssets/spotlight/spotlightAnimNew.json',
                  'assets/EndSceneAssets/spotlight',
                );
                this.load.start();
                load1 = true;
              }
              if (load3 == false) {
                this.load.multiatlas(
                  'rewardLight',
                  'assets/anims/rewardAnims/rewardLightAnim.json',
                  'assets/anims/rewardAnims/',
                );
                this.load.start();
                load3 = true;
              }
            }
          },
          [],
          this,
        );
      },
    });
  }

  cardSlide(container, y) {
    this.tweens.add({
      targets: container,
      y: y,
      ease: 'Power1',
      duration: 500,
      delay: 50,
      repeat: 0,
    });
  }

  cardChange() {
    if (gameState.questionNo == 5) {
      this.q1.setTexture('q5');
      this.q2.setTexture('q6');
      this.q3.setTexture('q7');
      this.q4.setTexture('q8');
    }

    if (gameState.questionNo == 6) {
      this.q1.setTexture('q9');
      this.q2.setTexture('q10');
      this.q3.setTexture('q11');
      this.q4.setTexture('q12');
    }

    if (gameState.questionNo == 7) {
      this.q1.setTexture('q13');
      this.q2.setTexture('q14');
      this.q3.setTexture('q15');
      this.q4.setTexture('q16');
    }
    if (gameState.questionNo == 8) {
      this.q1.setTexture('q17');
      this.q2.setTexture('q18');
      this.q3.setTexture('q19');
      this.q4.setTexture('q20');
    }
    if (gameState.questionNo == 9) {
      this.q1.setTexture('q21');
      this.q2.setTexture('q22');
      this.q3.setTexture('q23');
      this.q4.setTexture('q24');
    }
    if (gameState.questionNo == 10) {
      this.q1.setTexture('q25');
      this.q2.setTexture('q26');
      this.q3.setTexture('q27');
      this.q4.setTexture('q28');
    }
    if (gameState.questionNo == 11) {
      this.q1.setTexture('q29');
      this.q2.setTexture('q30');
      this.q3.setTexture('q31');
      this.q4.setTexture('q32');
    }
    if (gameState.questionNo == 12) {
      this.q1.setTexture('q33');
      this.q2.setTexture('q34');
      this.q3.setTexture('q35');
      this.q4.setTexture('q36');
    }
    if (gameState.questionNo == 13) {
      this.q1.setTexture('q37');
      this.q2.setTexture('q38');
      this.q3.setTexture('q39');
      this.q4.setTexture('q40');
    }

    if (gameState.correctCount < 6 && qno <= 10) {
      this.cardSlide(this.container1, 0);
      this.cardSlide(this.container2, 0);
      this.cardSlide(this.container3, 0);
      this.cardSlide(this.container4, 0);
    }
  }

  sceneEnd() {
    if (gameState.correctCount >= 6 || qno >= 10) {
      this.switch1.disableInteractive();
      this.switch2.disableInteractive();
      this.switch3.disableInteractive();
      this.switch4.disableInteractive();
    }
    gameState.cam = this.cameras.main;
    this.scene.launch('EndScene');
    this.scene.pause('GameScene');
  }

  update() {}
}
